import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class WebNotificationService {
  constructor(private readonly router: Router) {}
  projectUrl: string;
  webNotificationSound = [
    {
      sound_name: 'Synth',
      sound_id: 'synth',
      sound_path: 'assets/images/sounds/notification-1.mp3',
    },
    {
      sound_name: 'Generic',
      sound_id: 'generic',
      sound_path: 'assets/images/sounds/notification-2.mp3',
    },
    {
      sound_name: 'Alert',
      sound_id: 'alert',
      sound_path: 'assets/images/sounds/notification-3.mp3',
    },
    {
      sound_name: 'Alarm',
      sound_id: 'alarm',
      sound_path: 'assets/images/sounds/notification-4.mp3',
    },
    {
      sound_name: 'Chime',
      sound_id: 'chime',
      sound_path: 'assets/images/sounds/notification-5.mp3',
    },
  ];
  checkNotificationSupport(): void {
    if (!('Notification' in window)) {
      console.log('Notifications are not supported in this browser.');
    } else {
      console.log('Notifications are supported!');
    }
  }

  requestPermission(): Promise<NotificationPermission> {
    if (!('Notification' in window)) {
      return Promise.reject(new Error('Notifications not supported'));
    }
    return Notification.requestPermission();
  }

  showNotification(message, type): void {
    console.log('showNotification', Notification.permission);
    this.projectUrl = `/dashboard/liveagents?messageid=${message.id}&type=${type}`;
    const userData = JSON.parse(localStorage.getItem('user'))
      ? JSON.parse(localStorage.getItem('user'))
      : {};
    const userId = userData?.user_id ?? '';
    const projectDetail = userData.appSettings?.projectDetail;
    const webNotificationDetail = projectDetail?.WebNotificationStatusConfig;
    const configItem = webNotificationDetail?.find(
      (item) => item?.agentId === userId,
    );
    const defaultWebNotificationSound = this.webNotificationSound?.find(
      (item) => item?.sound_id === configItem?.sound_id,
    );
    if (!configItem?.enableWebNotification) {
      return;
    }
    if (message.appid !== userData.appid) {
      return;
    }
    if ('Notification' in window && Notification.permission === 'granted') {
      const notification = new Notification('Unified AI Livechat', {
        body: 'New message',
        icon: localStorage.getItem('companyNameLogoUrl')
          ? JSON.parse(localStorage.getItem('companyNameLogoUrl'))
          : 'assets/images/uib.png',
      });
      this.playNotificationSound(defaultWebNotificationSound);
      notification.onclick = () => {
        window.focus();
        console.log('Notification clicked');
        this.router.navigateByUrl(this.projectUrl);
      };
    }
  }
  playNotificationSound(defaultWebNotificationSound): void {
    const audio = new Audio(defaultWebNotificationSound?.sound_path);
    audio.play().catch((error) => console.error('Error playing sound:', error));
  }
}
